var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 60,
    viewBox: "0 0 228 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180231",
    "data-name": "Group 180231",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179145",
    "data-name": "Group 179145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6641",
    "data-name": "Rectangle 6641",
    width: 228,
    height: 40,
    rx: 4,
    fill: "#f0f5f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146790",
    "data-name": "Rectangle 146790",
    transform: "translate(94 12)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 16,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 14,
    rx: 1,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Rectangle",
    transform: "translate(0 -10)",
    fill: "#54565c",
    fontSize: 10,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Rectangle")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleHover);
export default __webpack_public_path__ + "static/media/RectangleHover.c65b0e24bc664b02090e8cd1245b99fa.svg";
export { ForwardRef as ReactComponent };